import { render, staticRenderFns } from "./newQuestion.vue?vue&type=template&id=09fb0bc6&scoped=true"
import script from "./newQuestion.vue?vue&type=script&lang=js"
export * from "./newQuestion.vue?vue&type=script&lang=js"
import style0 from "./newQuestion.vue?vue&type=style&index=0&id=09fb0bc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb0bc6",
  null
  
)

export default component.exports